module.exports = __webpack_public_path__ + "img/airbase-hotspot-1.1.741c6a84.png";